import axios from 'axios';

export const getProducts = async () => {
    const apiUrl = process.env.REACT_APP_API_BASE_URL;

    try {
        const params = new URLSearchParams({ statut: '1', en_avant: 'null' });
        const response = await axios.get(`${apiUrl}/front_formations?${params}`);
        return response.data;
    } catch (error) {
        console.error('Erreur lors de la récupération des formations :', error);
        throw error;
    }
};